import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
const AddTimelineEntryModel = ({ taskId, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    task_id: taskId,
    action_type: "REPLY_ADMIN",
    log_message: ""
  });
  const Auth = localStorage.getItem("authToken");
  const location = useLocation();


  if (!Auth) return <Navigate to="/login" state={{ from: location }} replace />;


  if (!taskId) return null;
  const Roles=[
    {
      name:"Reply(Admin)",
      type:"REPLY_ADMIN"
    },
    {
      name:"Reply to user(Admin)",
      type:"REPLY_ADMIN_TO_USER"
    },
    {
      name:"Completed by Admin",
      type:"COMPLETED_BY_ADMIN"
    }
  ]
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleSubmit = () => {
    
    if (onSubmit) {
      onSubmit(formData); 
    }
  };


  return (
    <div
      className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-white rounded-xl shadow-lg w-80 max-w-lg p-6 overflow-y-auto max-h-[90vh]">
        
        <div className="flex justify-between items-center border-b pb-3 mb-4">
          <h2 className="text-xl font-semibold text-gray-800">Add Timeline Entry</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 text-lg"
          >
            ✕
          </button>
        </div>

        
        <div className="space-y-4">
          <div>
            <label className="block font-semibold text-gray-700">Action Type</label>
            <select
              name="action_type"
              value={formData.action_type}
              onChange={handleChange}
              className="w-full border rounded-md px-3 py-2 mt-1"
            >
              
              {Roles.map((role) => (
                <option key={role.id} value={role.type}>
                  {role.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block font-semibold text-gray-700">Message</label>
            <input
              type="text"
              name="log_message"
              value={formData.log_message}
              onChange={handleChange}
              placeholder="Enter Message"
              className="w-full border rounded-md px-3 py-2 mt-1"
            />
          </div>

          

          

          

          
        </div>

       
        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
          >
            Submit
          </button>
        </div>
      </div>
       
        
      
    </div>
  );
};

export default AddTimelineEntryModel;


const formatDateTime = (value) => {
  if (!value) return "N/A";
  const date = new Date(value);
  return isNaN(date.getTime()) ? value : date.toLocaleString();
};
